export const planStackCodes = {
  list: "list",
  pdf: "pdf",
  forList: "forList",
};

export const defaultStackItem = {
  code: planStackCodes.list,
};
